import { render, staticRenderFns } from "./goodsDetail.vue?vue&type=template&id=0a399ec9&scoped=true&lang=html&"
import script from "./goodsDetail.js?vue&type=script&lang=js&"
export * from "./goodsDetail.js?vue&type=script&lang=js&"
import style0 from "./goodsDetail.styl?vue&type=style&index=0&id=0a399ec9&lang=stylus&scoped=true&"
import style1 from "./resetvant.styl?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a399ec9",
  null
  
)

export default component.exports